import i18n from "@/plugins/vue-i18n";

const NotFound = () => import(/* webpackChunkName: "error" */ "@/views/error/NotFoundPage.vue");

const notFound = [
  {
    path: "/404",
    name: "NotFound",
    component: NotFound,
    meta: {
      title: i18n.t("title.notFound"),
    },
  },
];

export default notFound;
